export interface ArtisanTrade {
    id: number;
    label: string;
}
